export default {"src":"/_next/static/media/error404.edc4569a.svg","height":244,"width":319,"blurWidth":0,"blurHeight":0};